import moment from "moment";
import DB from "../db";


export const InsertData = async (
  data,
  setNotificacionesVistas,
  setYesterdayData,
  setTodayData,
  setTomorrowData,
  setNotificaciones,
  setBadge
) => {
  const { result } = data;
  const db = new DB();

  let orden = 0; //parseInt(localStorage.getItem("orden"));

  if (isNaN(orden)) {
    orden = 0;
  }

  await db.deleteAll();

  for (var trip of result) {
    orden = orden + 1;
    trip.orden = orden;
    trip._id = `${trip.id}`;
    localStorage.setItem("orden", orden);
    await db.createLoad(trip);
  }

  if (result.length > 0 && result.filter((trip) => !trip.seen).length > 0) {
    const { titulo, cuerpo } = ObtenerDatosNotificacion(result);

    setNotificaciones({
      titulo,
      cuerpo,
    });

    setNotificacionesVistas(result);
    const tripsInDb = await db.getAll();

    const {
      yesterdayDataC,
      todayDataC,
      tomorrowDataC,
    } = getAllData(tripsInDb);

    setYesterdayData(yesterdayDataC);
    setTodayData(todayDataC);
    setTomorrowData(tomorrowDataC);

    setBadge({
      today_badge: todayDataC.filter((trip) => !trip.seen).length,
      tomorrow_badge: tomorrowDataC.filter((trip) => !trip.seen).length,
      yesterday_badge: yesterdayDataC.filter((trip) => !trip.seen).length,
    });
  } else {
    db.getAll().then((result) => {
      const {
        yesterdayDataC,
        todayDataC,
        tomorrowDataC,
      } = getAllData(result);
      setYesterdayData(yesterdayDataC);
      setTodayData(todayDataC);
      setTomorrowData(tomorrowDataC);
    });
  }
};

export const getAllData = (data) => {
  const newData = data.map((load) => {
    return load.doc;
  });


  const newDataOrder = newData.sort((x, y) => {
    return x.orden - y.orden;
  });

  const yesterday = moment(new Date()).add(-1, "days").format("YYYY-MM-DD");
  const tomorrow = moment(new Date())
    .add(+1, "days")
    .format("YYYY-MM-DD");
  const yesterdayDataC = [];
  const todayDataC = [];
  const tomorrowDataC = [];


  for (var trip of newDataOrder) {
    const tripDate = moment(trip.tripDate).format("YYYY-MM-DD");
    if (tripDate === moment(new Date()).format("YYYY-MM-DD")) {
      todayDataC.push(trip);
    }

    if (tripDate === yesterday) {
      yesterdayDataC.push(trip);
    }

    if (tripDate === tomorrow) {
      tomorrowDataC.push(trip);
    }
  }

  return {
    yesterdayDataC,
    todayDataC,
    tomorrowDataC
  };

};

const ObtenerDatosNotificacion = (trips) => {
  let titulo = "";
  let cuerpo = "";
  const language = localStorage.getItem("language");

  const tripsNotSeen = trips.filter((trip) => !trip.seen);

  titulo = language === "en" ? "New Trip" : "Nuevo Viaje";
  cuerpo =
    language === "en"
      ? `You have ${tripsNotSeen.length} new trips`
      : `Tienes ${tripsNotSeen.length} nuevos viaje`;

  // if (loads.new && loads.new.total !== "0") {
  //   titulo = language === "en" ? "New Trip" : "Nuevo Viaje";
  //   cuerpo =
  //     language === "en"
  //       ? `You have ${loads.new.total} new trips`
  //       : `Tienes ${loads.new.total} nuevos viaje`;
  // } else if (loads.edit && loads.edit.total !== "0") {
  //   titulo = language === "en" ? "Edited Trip" : "Viaje Editado";
  //   cuerpo =
  //     language === "en"
  //       ? `${loads.edit.total} trips have been edited`
  //       : `Se han editado ${loads.edit.total} viajes`;
  // } else if (loads.cancel && loads.cancel.total !== "0") {
  //   titulo = language === "en" ? "Trip cancellation" : "Cancelación de viaje";
  //   cuerpo =
  //     language === "en"
  //       ? `Have been canceled ${loads.cancel.total} trips`
  //       : `Se han cancelado ${loads.cancel.total} viajes`;
  // }
  return {
    titulo,
    cuerpo,
  };
};
